import { useTranslation } from 'react-i18next';
import HebrewDatePicker from '../common/HebrewDatePicker';
import {
  getTodayString,
  getNextShabbos,
  getNextRoshChodesh,
  getNextYomTov,
} from '../../utils/dateShortcuts';

interface DaySelectorProps {
  selectedDate: string;
  onChange: (date: string) => void;
}

export default function DaySelector({ selectedDate, onChange }: DaySelectorProps) {
  const { t } = useTranslation();

  const shortcuts = [
    { key: 'today', date: getTodayString(), label: t('shul.today') },
    { key: 'nextShabbos', date: getNextShabbos(), label: t('shul.nextShabbos') },
    {
      key: 'nextRoshChodesh',
      date: getNextRoshChodesh(),
      label: t('shul.nextRoshChodesh'),
    },
    { key: 'nextYomTov', date: getNextYomTov(), label: t('shul.nextYomTov') },
  ];

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
      <HebrewDatePicker selectedDate={selectedDate} onChange={onChange} />
      <div className="flex flex-wrap gap-2">
        {shortcuts.map(({ key, date, label }) => {
          const isActive = date === selectedDate;
          return (
            <button
              key={key}
              type="button"
              onClick={() => onChange(date)}
              className={`text-xs px-3 py-1.5 rounded-[10px] transition-colors ${
                isActive ? 'bg-ink text-paper' : 'bg-fog text-ink'
              }`}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
